import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  static targets = ['copyBtn'];

  static values = {
    copiedText: String,
    textToCopy: String,
  };

  copyTextValue(event) {
    event.preventDefault();

    const targetValue = event.currentTarget.dataset.targetValue;

    navigator.clipboard.writeText(targetValue);

    this.#updateTooltipWording(event.currentTarget);
  }

  #updateTooltipWording(item) {
    let tooltipContainer = item;

    tooltipContainer.setAttribute(
      'data-bs-original-title',
      this.copiedTextValue
    );

    let btnTooltip = bootstrap.Tooltip.getInstance(tooltipContainer);
    btnTooltip.show();

    tooltipContainer.setAttribute(
      'data-bs-original-title',
      this.textToCopyValue
    );
  }
}
